import BlankIcon from '@assets/icons/file-blank-small.svg';
import CSVIcon from '@assets/icons/file-csv-small.svg';
import ImageIcon from '@assets/icons/file-image-small.svg';
import PDFIcon from '@assets/icons/file-pdf-small.svg';
import React, { forwardRef } from 'react';
import { StyleSheet, View } from 'react-native';
import { SvgProps } from 'react-native-svg';
import { Tag } from './tag';
import { useTheme } from '@/contexts/theme-context';

export enum FileTagIconType {
  CSV = 'CSV',
  DEFAULT = 'DEFAULT',
  IMAGE = 'IMAGE',
  PDF = 'PDF',
}

const FileIcons: Record<FileTagIconType, React.ComponentType<SvgProps>> = {
  CSV: CSVIcon,
  DEFAULT: BlankIcon,
  IMAGE: ImageIcon,
  PDF: PDFIcon,
};

interface Props {
  children: React.ReactNode;
  iconType?: FileTagIconType;
  isHovered?: boolean;
  isSelected?: boolean;
}

export const FileTag = forwardRef<View, Props>(
  ({ isHovered, isSelected, iconType, children }, ref) => {
    const theme = useTheme();
    const Icon = iconType ? (FileIcons[iconType] ?? null) : null;
    const prefixComponent = Icon ? (
      <Icon fill={theme.sk.color.icon.primary} style={styles.icon} />
    ) : null;
    return (
      <Tag
        isHovered={isHovered}
        isSelected={isSelected}
        prefixComponent={prefixComponent}
        ref={ref}
        textStyle={prefixComponent ? styles.fileText : null}
      >
        {children}
      </Tag>
    );
  },
);

const styles = StyleSheet.create({
  fileText: {
    maxWidth: 96,
  },
  icon: {
    flexShrink: 0,
  },
});
